import { DefaultLocale, Locale, LocalValuesLowercase } from "@/types/awsm";

function isLocale(value: string): boolean {
  return LocalValuesLowercase.includes(value.toLowerCase());
}

/**
 * Safely converts a string to a Locale type
 * Returns the default locale for specific invalid cases like empty strings or malformed locales
 */
export function convertToLocale(value: string): Locale {
  if (isLocale(value)) {
    return value as Locale;
  }

  return DefaultLocale;
}
